// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./ExpandIcon.data";

export const ExpandIcon = createIcon("ExpandIcon", iconNode);
